module.exports = (__webpack_require__(9))(2675);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/apollo-link-context/lib/bundle.esm.js from dll-reference vendor_cd7e7d937ca142ef7142
// module id = 144
// module chunks = 10